export default __webpack_public_path__ + "static/media/gallery 1.e0ecb595.png";